/* global bsBreakpoints keyboardNavigation */
(() => {
    const root = document.querySelector('[data-js-header-search-root]');
    const input = root.querySelector('[data-drupal-selector="edit-text"]');
    const button = root.querySelector('[data-js-header-search-toggle]');

    const floatingLabel = () => {
		const label = root.querySelector('label');

        input.addEventListener('focus', () => {
            label.classList.add('floating');
        });

        input.addEventListener('focusout', () => {
            if(input.value.length === 0) {
                label.classList.remove('floating');
            }
		});
		
		if (input.value.length !== 0) {
			label.classList.add('floating');
		} else {
			if(label.classList.contains('floating')) {
				label.classList.remove('floating');
			}
		}
    }

    const openSearch = () => {
        button.addEventListener('click', () => {
            if(!root.classList.contains('open-search')) {
                document.querySelector('body').classList.add('open-search');
                root.classList.add('open-search');
                button.classList.add('close-btn');
                button.setAttribute('data-icon', 'cross');
                root.focus();
                keyboardNavigation(root);
            } else {
                document.querySelector('body').classList.remove('open-search');
                root.classList.remove('open-search');
                button.classList.remove('close-btn');
                button.setAttribute('data-icon', 'search');
                button.focus();
            }
        })
    }

    const init = () => {
        if(root) {
            floatingLabel();
            openSearch();
        }
    }

    init();
})();